module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/misterdonut-34188452125a344938d8d2d66d64946e.jpg";